import WebServiceRequest from '../Api/WebServiceRequest'

class QuestionGetAllByTitle extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('PsychologicalTestQuestion/GetList')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

class QuestionEdit extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('PsychologicalTestQuestion/Update')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

export {
    QuestionGetAllByTitle,
    QuestionEdit
}